import React from 'react'
import Header from '../components/Header'
import '../assets/css/TodayPrize.scss'
import '../assets/css/PlayerWaitingScreen.css'
import Ads1 from "../assets/images/TodayPrizeScreen/today_prize_1.svg"
import Ads2 from "../assets/images/TodayPrizeScreen/today_prize2.svg"
import Ads3 from "../assets/images/TodayPrizeScreen/today_prize_3.svg"
import Ads4 from "../assets/images/TodayPrizeScreen/today_prize_4.svg"
import Ads5 from "../assets/images/TodayPrizeScreen/today_prize_5.svg"
import BottomAd1 from "../assets/images/TodayPrizeScreen/bottom-ad-1.png"
import BottomAd2 from "../assets/images/TodayPrizeScreen/bottom-ad-2.png"
import PlayerWaitingImg1 from '../assets/images/PlayerWaiting/PlayerWaitingImg1.png'
import PlayerWaitingImg2 from '../assets/images/PlayerWaiting/PlayerWaitingImg2.png'
import PlayerWaitingImg3 from '../assets/images/PlayerWaiting/PlayerWaitingImg3.png'
import Announcement from '../components/TodayPrize/announcement'
import NextPrizeCardAd from '../components/TodayPrize/nextPrizeCardAdd'
import Footer from '../components/Footer'
import TodayPrizeCard from '../components/TodayPrize/todayPrizeCard'
import { useNavigate } from "react-router-dom";

export default function TodayPrize() {
    const navigate = useNavigate();

    const moveToNext = () => {
        // navigate("/playerscreen");
    }

    return (
        <div className='' style={{ overflow: "hidden" , minHeight:"100vh", backgroundColor:"black"}}>

          <Header />

            <div className='today ' style={{height:"73vh"}}>

                <div className='row ' style={{height:"73vh"}}>
                    <div className='col-3  ' style={{height:"100%"}} >
                        <div className="row pr-3" style={{height:"100%"}}>

                            <div className="col-12 d-flex justify-content-center" style={{height:"50%"}}>

                                <img width={"78%"}  src={Ads1} />


                            </div>

                            <div className="col-12 d-flex justify-content-center" style={{height:"50%"}}>

                                <img width={"78%"} src={Ads2} />

                            </div>

                        </div>
                    </div>

                    <div className='col-6 pl-0 '>
                        <div className='row ' onClick={moveToNext}>
                            <TodayPrizeCard />
                        </div>
                        <div className='row'>
                            <div className='col-12  px-4 mt-2 next-prize'>
                                <Announcement title={"NEXT PRIZES"} />
                                <NextPrizeCardAd />
                            </div>
                        </div>
                        {/* <div className='row'>
                            <div className="col-6 p-0 mt-2">

                              
                                    <img style={{width:"100%", height:"100%"}} src={BottomAd1} />

                            </div>

                            <div className="col-6 p-0 mt-2">

                                    <img style={{width:"100%", height:"100%"}} src={BottomAd2} />
                              

                            </div>
                        </div> */}
                    </div>


                    <div className="col-3" style={{ height: "100%" }}>
                        <div className="row" style={{ height: "100%" }}>

                            <div className="col-12 mb-2" style={{ height: "40%" }}>

                                <img style={{ height: "100%" }} className='player-waiting-right-img1' src={PlayerWaitingImg1} alt="" />

                            </div>

                            <div className="col-12 mb-2" style={{ height: "25%" }}>

                                <img style={{ height: "100%" }} className='player-waiting-right-img2' src={PlayerWaitingImg2} alt="" />

                            </div>

                            <div className="col-12" style={{ height: "31.5%" }}>

                                <img style={{ height: "100%" }} className='player-waiting-right-img3' src={PlayerWaitingImg3} alt="" />

                            </div>

                        </div>
                    </div>
                </div>


                <div className='col-12' style={{position:"fixed", bottom:"0", backgroundColor:"black"}}>

                    <Footer NextPage="/playerscreen" BackPage={"/"} BackText="WELCOME" />

</div>


            </div>

        </div>
    )
}
